<select #selectId [id]="id" [class]="class" [data-search]="false" multiple></select>